/* istanbul ignore file */
import useQuery, { QueryOptions } from 'hooks/useQuery';
import {
  getRefundsAMC as action,
  resetGetRefundsAMC as resetAction,
} from 'store/sinistre/actions';
import { getAmcRefundsSelector as selector } from 'store/sinistre/selectors';

const calculateLength = (data: any = {}) =>
  Object.keys(data).reduce((acc, key) => acc + data[key]?.length, 0);

const useRefunds = (params?: QueryOptions) => {
  const { data, loading, error, get: _get, reset, page = 1, total } = useQuery({
    action,
    resetAction,
    selector,
    resetOnUnmount: false,
    ...params,
  });

  const get = (payload: any) => reset() && _get(payload);

  const length = calculateLength(data);

  const hasMore = total > length;

  const loadMore = (payload: any) =>
    hasMore && _get({ ...payload, page: page + 1 });

  return {
    data,
    loading,
    error,
    get,
    loadMore,
    reset,
    hasMore,
    length,
  };
};

export default useRefunds;
